<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close style="display: none;">
      <span class="material-symbols-outlined">close</span>
    </div>
  </div>
</div>



<mat-dialog-content>

  <div style="text-align: center;">

    <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
      <span class="material-symbols-outlined" style="color:#3BA46F;font-size: 45px;">task</span>
    </div>

    <div class="label-dialog-strong">{{title}}</div>
    <div class="label-dialog">{{subtitle}}</div>


    @if (open_as_sim == false) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="primary-button" mat-flat-button (click)="adjuntar_files()">
              Adjuntar
            </button>
            <button class="secondary-button" mat-flat-button (click)="ver_estado()">
              Ver estado
            </button>
          </div>
        </div>
      </div>
    }

    @if (open_as_sim == true) {
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            @if(onboarding == false){
              <button class="primary-button" mat-flat-button (click)="ver_estado()">
                Ver estado
              </button>
              }@else{
              <button class="primary-button" mat-flat-button (click)="continue()">
                Continuar
              </button>
            }
          </div>
        </div>
      </div>
    }

  </div>



</mat-dialog-content>